<template>
  <div id="app">
    <router-view class="router-view" :style="{ background: indexInfo.bg }" />
  </div>
</template>
<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import { url2json, generateFingerprintSaveToLocalStorage, LOCAL_STORAGE_TRACK } from '@utils';
import { getchannel } from '@api/userchannel';
import { formOther } from '@utils/track';

export default {
  computed: {
    ...mapState({
      indexInfo: state => state.indexInfo,
      channelId: state => state.channelId,
      s: state => state.s,
      platform: state => state.platform
    })
  },
  mounted() {
    /** 生成设备唯一标识 */
    generateFingerprintSaveToLocalStorage();
    //初始化大数据埋点;
    window.sfjsPoint.init({
      appKey: 'market_userchannel', // 渠道拉新h5
      environment: 'production', //'production' / "development"
      showLog: true, // 是否允许控制台打印查看埋点数据,
      reportArrLimit: 1,
      getBusinessParamsFn: () => {
        console.log('aaaa', this);
        return {
          open_id: localStorage.getItem(LOCAL_STORAGE_TRACK) || '',
          source: 'h5', // 端
          channelId: this.channelId,
          s: this.s,
          platform: this.platform
        };
      }
    });

    const params = url2json();
    getchannel({
      inviter_token: params.s
    }).then(res => {
      this.setState({
        channelId: res.pull_channel || '',
        s: res.s,
        platform: res.order_channel
      });
      // 埋点
      window.sfjsPoint.track('enter_home_page'); // 到首页
    });
    const obj = formOther(params);
    if (obj) {
      this.setState({
        advInfo: {
          channel: obj.type,
          clickId: obj.click_id
        }
      });
    }
    this.setState({
      urlQuery: params
    });
    this.$nextTick(() => {
      this.wechatInit();
    });
  },
  methods: {
    ...mapActions(['wechatInit']),
    ...mapMutations(['setState'])
  }
};
</script>
<style lang="less">
.router-view {
  background: #4a0405;
}
</style>
